import * as yup from 'yup';

export default function getValidationSchema() {
  return yup.object({
    description: yup
      .string()
      .trim()
      .required("обов'язкове поле")
      .max(2000, `Будь ласка, введіть опис довжиною до 2000 символів.`)
  });
}
